import React from 'react';

import { isTabletOrWeb } from 'utils/responsiveness';

import SubtitleAudioDropDown from './SubtitleAudioDropDown';
import SubtitleAudioOverlay from './SubtitleAudioOverlay';
import { IProps } from './types';

function SelectAudioAndSubtitles(props: IProps) {
    const Selector = isTabletOrWeb
        ? SubtitleAudioDropDown
        : SubtitleAudioOverlay;

    return <Selector {...props} />;
}

export default React.memo(SelectAudioAndSubtitles);
